export default __webpack_public_path__ + "static/media/site_manager.9e2c28af.svg";